import axios from "axios";

/**
 * Axios instance pointed at Django's REST API.
 *
 * The Vite dev server proxies /api/* to http://localhost:8000, so a
 * relative `baseURL` works in both dev and production builds (where
 * Django serves the SPA from the same origin).
 *
 * `withCredentials: true` ships the Django session cookie on every
 * request — that's how DRF's SessionAuthentication picks the user up.
 */
export const api = axios.create({
  baseURL: "/api/v1",
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});
